import commonStyles from "./common.module.css"

export default function FieldError({ error }: Props) {
  return error
    ? <span className={commonStyles.fieldError}>{error}</span>
    : <></>
}

interface Props {
  error?: string;
}

export type FormErrors<T> = {
  [K in keyof T]?: string;
}

export type FormErrorsArr<T> = FormErrors<T>[]
